import React, { useState } from 'react';
import { node, bool, arrayOf, shape, number, string, oneOf } from 'prop-types';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useTheme } from '@mui/material/styles';
import { InnerContentWrapper } from '../../Organisms';
import { Elevations } from '../../Foundation';
export const PageTabs = _ref => {
  let {
    tabPanels,
    tabLabels,
    size,
    usedViewHeight,
    defaultTab
  } = _ref;
  const [tabIndex, setTabIndex] = useState(defaultTab || tabLabels[0].key);
  const {
    backgroundColors
  } = useTheme().palette;
  const handleChange = (_event, newValue) => {
    setTabIndex(newValue);
  };
  const tabBarHeight = 64;
  return /*#__PURE__*/React.createElement(TabContext, {
    value: tabIndex
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxShadow: Elevations.elevation,
      position: 'relative',
      zIndex: 10
    }
  }, /*#__PURE__*/React.createElement(InnerContentWrapper, {
    size: size
  }, /*#__PURE__*/React.createElement(TabList, {
    onChange: handleChange,
    "aria-label": "tabs",
    "data-test-id": "tabs",
    variant: "scrollable",
    scrollButtons: "auto"
  }, tabLabels.map(_ref2 => {
    let {
      label,
      key,
      disabled
    } = _ref2;
    return /*#__PURE__*/React.createElement(Tab, {
      "data-test-id": "tab",
      key: key,
      value: key,
      label: label,
      disabled: disabled,
      disableRipple: true
    });
  })))), tabPanels.map(_ref3 => {
    let {
      item,
      colorVariant,
      key
    } = _ref3;
    return /*#__PURE__*/React.createElement(TabPanel, {
      key: key,
      value: key,
      sx: {
        backgroundColor: backgroundColors[colorVariant],
        minHeight: "calc(100vh - ".concat(tabBarHeight + usedViewHeight, "px)"),
        boxSizing: 'border-box'
      }
    }, item);
  }));
};
PageTabs.propTypes = {
  tabLabels: arrayOf(shape({
    label: node,
    disabled: bool,
    key: string
  })),
  tabPanels: arrayOf(shape({
    index: number,
    item: node,
    colorVariant: oneOf(['light', 'dark'])
  })),
  size: oneOf(['small', 'medium', 'large']),
  usedViewHeight: number,
  defaultTab: string
};
PageTabs.defaultProps = {
  tabLabels: [{
    label: null,
    disabled: false,
    index: '',
    key: ''
  }],
  tabPanels: [{
    index: '',
    item: null,
    colorVariant: 'dark'
  }],
  size: 'medium',
  usedViewHeight: 0,
  defaultTab: null
};